import React, { memo, useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Query } from '@material-table/core';
import { Container, MailDialog, MTable, RepealableName } from '../../../../../Components';
import { useFilter } from '../../../../../Components/ListFilter/useFilter';
import { IGridQueryRequest, OrderDirection } from '../../../../../Api/AptorApi';
import { useAptorApi } from '../../../../../Api';
import moment from 'moment';
import { Button, RadioGroup, Tooltip } from '@material-ui/core'
import { ArrowUpward, Edit } from '@material-ui/icons'
import { ObservationFilter } from './Filters';
import { ComplianceReportCheckbox } from '../../../Components/Compliance/Checkbox';
import { useIsMounted } from '../../../../../Hooks/useIsMounted';
import { useStyles } from '../CarryLK/CreateDirectCompliance.style';
import EditObservationModal from './EditObservationModal';


const IconsNode = memo(({ rowData, formatMessage, onEdit }: any) => {
  const classes = useStyles();
  return (
    <>
      <div style={{ width: 28, display: 'inline-flex', justifyContent: 'center' }}>
        <Tooltip title={formatMessage({ id: 'law-portal.legal.plan.edit' })}>
          <div style={{ cursor: 'pointer', display: 'inline-flex', padding: '4px' }} onClick={(e) => { e.stopPropagation(); onEdit(rowData); }}>
            <Edit fontSize="small" />
          </div>
        </Tooltip>
      </div>
    </>
  );
});

export const Observation = () => {
  const { formatMessage } = useIntl();
  const { api, abortController } = useAptorApi();
  const tableRef = React.useRef<any>(null);
  const [filters, setFilter] = useFilter();
  const isMounted = useIsMounted();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [tableKey, setTableKey] = useState<number>(0);

  const handleEditClick = useCallback((rowData: any) => {
    setSelectedRowData(rowData);
    setModalOpen(true);
  }, []);

  const handleSaveSuccess = useCallback(() => {
    tableRef.current?.onQueryChange();
  }, []);

  useEffect(() => {
    if (isMounted) {
      // Increment table key to force remount and clear cached data
      // This will automatically trigger a fresh data fetch
      setTableKey(prev => prev + 1);
      setSelectedRowData(null);
    }
  }, [filters, isMounted]);


  const handleDataFetch = useCallback(
    async (query: Query<any>) => {
      try {
        const response = await api.searchObservation<any>({
          orderDirection: query.orderDirection === 'asc' ? OrderDirection.Ascending : OrderDirection.Descending,
          orderBy: query.orderBy !== undefined ? query.orderBy.field : 'createdAt',
          page: query.page,
          pageSize: query.pageSize,
          search: query.search,
          filters: { ...filters, status: filters.status?.length ? filters.status[0] : null },
        } as IGridQueryRequest);
        return {
          data: response?.data || [],
          page: response?.page || 0,
          totalCount: response?.totalCount || 0,
        };
      } catch (error) {
        console.error('Error fetching observations:', error);
        throw error;
      }
    },
    [api, filters],
  );


  return (
    <>
      <ObservationFilter filters={filters} setFilter={setFilter} />
      <hr style={{ marginTop: '25px', marginBottom: "25px" }} />
      <MTable
        key={tableKey}
        tableRef={tableRef}
        columns={[
          { title: formatMessage({ id: 'law-portal.our-laws.table.number' }), field: 'number', hidden: false },
          {
            title: formatMessage({ id: 'law-portal.our-laws.table.law' }),
            field: 'legislationName',
            render: (row: any) => <RepealableName name={row.legislationName} effectiveTo={null} />,
            hidden: false
          },
          {
            title: formatMessage({ id: 'law-portal.legal.compliance.sub-menu.comformities.description' }),
            field: 'answer',
            hidden: false,
            sorting: false,
            width: 350, // fixed width in pixels
            cellStyle: { minWidth: 500, maxWidth: 500, whiteSpace: 'normal', flex: '0 0 500px' },
            headerStyle: { minWidth: 500, maxWidth: 500, whiteSpace: 'normal', flex: '0 0 500px' },
          },
          {
            title: formatMessage({ id: 'law-portal.compliance.report.table.col' }),
            field: 'responsibleUser',
            render: (row: any) => {
              if (row.responsibleUser) {
                const responsiblearr = row?.responsibleUser?.split(',')
                return (
                  <>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      {responsiblearr?.map((val: any) => {
                        return <span>{val}</span>
                      })}
                    </div>
                  </>
                )
              } else {
                return "-"
              }
            },
            sorting: false,
            hidden: false
          },
          {
            title:formatMessage({ id: 'law-portal.legal.compliance.sub-menu.reports.observations' }),
            field: '',
            // width: '35%',
            align: 'center',
            render: (row: any) => {
              return (
             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 48 }}>
      <RadioGroup row>
        {row?.compliance === "deficiency" && (
          <ComplianceReportCheckbox type="deficiency" value={row?.compliance} hidden={false} />
        )}
        {row?.compliance === "no" && (
          <ComplianceReportCheckbox type="no" value={row?.compliance} hidden={false} />
        )}
        {row?.compliance === "yes" && (
          <ComplianceReportCheckbox type="yes" value={row?.compliance} hidden={false} />
        )}
      </RadioGroup>
    </div>
              )
            },
            sorting: false,
            hiddenByColumnsButton: true
          },
          // {
          //   title: "",
          //   field: '',
          //   width: '10%',
          //   cellStyle: { whiteSpace: 'nowrap' as const, padding: '4px 8px', maxWidth: 'none' },
          //   headerStyle: { whiteSpace: 'nowrap' as const, padding: '4px 8px', maxWidth: 'none' },
          //   render: (row: any) => (
          //     <IconsNode
          //       rowData={row}
          //       formatMessage={formatMessage}
          //       onEdit={handleEditClick}
          //     />
          //   ),
          //   sorting: false,
          //   hiddenByColumnsButton: true
          // },
        ]}
        data={handleDataFetch}

      />
      {selectedRowData && <EditObservationModal open={modalOpen} setOpen={setModalOpen} rowData={selectedRowData} onSaveSuccess={handleSaveSuccess} />}
    </>

  );
};
